import { hasExpired, } from './instant-items-state.js';
export const registerInstantItem = (payload, state) => {
    const { id } = payload;
    if (state[id]) {
        return;
    }
    state[id] = { q: '', cache: {} };
    return state;
};
export const updateInstantItemQuery = (payload, state) => {
    const { q, id } = payload;
    if (!q) {
        return;
    }
    state[id].q = q;
};
export const clearExpiredItems = (payload, state) => {
    const { id } = payload;
    Object.entries(state[id].cache).forEach(([q, cached]) => {
        if (hasExpired(cached)) {
            delete state[id].cache[q];
        }
    });
};
export const fetchItemsPending = (payload, state, toSetEmptyIfNotFound) => {
    for (const id in state) {
        for (const query in state[id].cache) {
            state[id].cache[query].isActive = false;
        }
    }
    if (!getCached(payload, state)) {
        makeEmptyCache(payload, state, toSetEmptyIfNotFound);
        return;
    }
    const cached = getCached(payload, state);
    cached.isLoading = true;
    cached.isActive = true;
    cached.error = null;
};
export const fetchItemsFulfilled = (payload, state, toAddToCache) => {
    const { id, q, searchUid, cacheTimeout, totalCountFiltered, duration } = payload;
    state[id].cache[q] = {
        ...getCached(payload, state),
        ...toAddToCache,
        isActive: true,
        searchUid,
        isLoading: false,
        error: null,
        expiresAt: cacheTimeout ? cacheTimeout + Date.now() : 0,
        totalCountFiltered,
        duration,
    };
};
export const fetchItemsRejected = (payload, state) => {
    const { id, q, error } = payload;
    state[id].cache[q].error = error || null;
    state[id].cache[q].isLoading = false;
    state[id].cache[q].isActive = false;
};
const getCached = (payload, state) => {
    const { q, id } = payload;
    return state[id].cache[q] || null;
};
const makeEmptyCache = (payload, state, setToEmpty) => {
    const { q, id } = payload;
    state[id].cache[q] = {
        isLoading: true,
        error: null,
        expiresAt: 0,
        isActive: true,
        searchUid: '',
        totalCountFiltered: 0,
        duration: 0,
        ...setToEmpty,
    };
};
